var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"xl":"3","lg":"3","md":"3","cols":"12"}},[_c('v-card',{attrs:{"flat":"","height":"100%"}},[_c('v-card-subtitle',{staticClass:"pb-0 pt-2 caption"},[_vm._v(_vm._s(_vm.title))]),_c('v-card-title',{staticClass:"subtitle-2 pt-0 pb-2"},[_vm._v(_vm._s(_vm.info))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }